import request from "@/utils/request";

// https://console-docs.apipost.cn/preview/4b7ee029c8760e2f/e220dbee4465a69e?target_id=71d32e6b-e76a-4411-b6de-aad1166a2c90 
/**
 * 一级标签列表
 * @param {*} params 
 * @returns 
 */
export function getFirstTagList(params) {
    return request({
        url: "/community/custom.php?module=doc&mod=directory&ac=parenttag",
        method: "get",
        params
    });
}
/**
 * 一级标签列表 管理端
 * @param {*} params 
 * @returns 
 */
export function manageGetFirstTag(params) {
    return request({
        url: "/community/custom.php?module=doc&mod=document&ac=manageGetFirstTag",
        method: "get",
        params
    });
}
/**
* 二级标签列表
* @param {*} params 
* @returns 
*/
export function getSecondTagList(params) {
   return request({
       url: "/community/custom.php?module=doc&mod=directory&ac=secondtag",
       method: "get",
       params
   });
}

/**
 * 文档专区页-标签列表&目录列表
 * @param {*} params 
 * @returns 
 */
export function getDocList(params) {
    return request({
        url: "/community/custom.php?module=doc&mod=directory&ac=directorylist",
        method: "get",
        params
    });
}

/**
 * 文档专区页-获取文章
 * @param {*} params 
 * @returns 
 */
export function getArticle(params) {
    return request({
        url: "/community/custom.php?module=doc&mod=directory&ac=article",
        method: "get",
        params
    });
}

/**
 * 搜索
 * @param {*} params 
 * @returns 
 */
export function keywordSearch(params) {
    return request({
        url: "/community/custom.php?module=doc&mod=directory&ac=search",
        method: "get",
        params
    });
}

/**
 * 【需登录】根据标签和上级目录id查看目录
 * @param {*} params 
 * @returns 
 */
export function viewdirectory(params) {
    return request({
        url: "/community/custom.php?module=doc&mod=document&ac=manageGetDirectory",
        method: "get",
        params
    });
}

/**
 * 【需登录】移动目录
 * @param {*} params 
 * @returns 
 */
export function movingDirectories(data) {
    return request({
        url: "/community/custom.php?module=doc&mod=document&ac=manageMigrateArticle",
        method: "post",
        data
    });
}

/**
 * 【需登录】预览文档根据文档id 
 * @param {*} params 
 * @param {*} ac //articlebycontent 预览根据修改内容  articlebyid 根据id
 * @returns 
 */
export function preview(data,ac) {
    return request({
        url: `/community/custom.php?module=doc&mod=preview&ac=${ac}`,
        method: "post",
        data
    });
}
//版本筛选框列表
export function getVersionFilterList( ) {
    return request({
        url: "/community/custom.php?module=doc&mod=directory&ac=version",
        method: "get",
    })
}

//版本筛选框列表-管理端 仅供管理员使用
export function adminGetVersionFilterList(params) {
    return request({
        url: "/community/custom.php?module=doc&mod=document&ac=manageGetVersion",
        method: "get",
        params
    })
}



//版本筛选框列表
export function getBluePrint(params) {
    return request({
        url: "/community/custom.php?module=doc&mod=directory&ac=bluePrint",
        method: "get",
        params
    })
}

/**
 * 创建划词评论
 * @param {*}  
 */
export function createArticleWordsComment(data) {
    return request({
        url: `/community/custom.php?module=doc&mod=directory&ac=createArticleWordsComment`,
        method: "post",
        data
    });
}

/**
 * 添加划词评论
 * @param {*}  
 */
export function insertArticleWordsComment(data) {
    return request({
        url: `/community/custom.php?module=doc&mod=directory&ac=insertArticleWordsComment`,
        method: "post",
        data
    });
}

/**
 * 编辑划词评论
 * @param {*}  
 */
export function updateArticleWordsComment(data) {
    return request({
        url: `/community/custom.php?module=doc&mod=directory&ac=updateArticleWordsComment`,
        method: "post",
        data
    });
}

/**
 * 划词评论列表
 * @param {*}  
 */
export function articleWordsCommentList(params) {
    return request({
        url: `/community/custom.php?module=doc&mod=directory&ac=articleWordsCommentList`,
        method: "get",
        params
    });
}

/**
 * 点赞划词评论
 * @param {*}  
 */
export function likeArticleWordsComment(data) {
    return request({
        url: `/community/custom.php?module=doc&mod=directory&ac=likeArticleWordsComment`,
        method: "post",
        data
    });
}

/**
 * 删除划词评论 管理删除划词评论
 * @param {*}  
 */
export function deleteArticleWordsComment(data,ac) {
    return request({
        url: `/community/custom.php?module=doc&mod=directory&ac=${ac}`,
        method: "post",
        data
    });
}


/**
 * 获取点踩问题列表
 * @param {*}  
 */
export function getArticleWordsCommentDislikeList(params) {
    return request({
        url: `/community/custom.php?module=doc&mod=feedback&ac=reason`,
        method: "get",
        params
    });
}
/**
 *  文档内容点赞
 * @param {*}  
 */
export function likeArticleContent(data) {
    return request({
        url: `/community/custom.php?module=doc&mod=feedback&ac=like`,
        method: "post",
        data
    });
}

/**
 * 文档内容点踩
 * @param {*}  
 */
export function dislikeArticleContent(data) {
    return request({
        url: `/community/custom.php?module=doc&mod=feedback&ac=dislike`,
        method: "post",
        data
    });
}